export const iconFontAwesomeBuildingsBuilding = (
	<i className="fa-solid fa-building"></i>
);
